import { PieChart, PieChartProps } from '../../../renderers/pie-chart/pie-chart.component';
import { EQUIPMENT_STATE_ALL_DONUT_CHART_DEFINITION } from './equipment-state-all-donut-chart.definition';
import { EQUIPMENT_STATE_ALL_DONUT_CHART_MOCK_DATA } from './equipment-state-all-donut-chart.mock';

export const EquipmentStateAllDonutChart = (props: PieChartProps) => (
    <PieChart
        {...props}
        variant='donut'
        showSliceValues
    />
);

EquipmentStateAllDonutChart.definition = EQUIPMENT_STATE_ALL_DONUT_CHART_DEFINITION;
EquipmentStateAllDonutChart.mockData = EQUIPMENT_STATE_ALL_DONUT_CHART_MOCK_DATA;
